<template>
  <div
    class="h-screen w-screen flex items-center content-center justify-center bg-gray-900"
  >
    <div
      class="flex flex-col text-left space-y-4 max-w-md bg-white w-full p-4 rounded-lg"
      v-if="!error && userData !== null"
    >
      <h1 class="font-medium text-xl text-center">Unsubscribe from Emails</h1>
      <div class="block" data-children-count="1">
        <label class="block text-sm font-medium text-gray-700" for="email"
          >Email Address</label
        >
        <input
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          type="email"
          name="email"
          id="email"
          v-model="userData.email"
          disabled
          required
        />
      </div>

      <button
        class="w-full py-2 text-white rounded-md focus:outline-none"
        :class="{
          'bg-green-600': userData.email_manual_disabled,
          'bg-blue-600': !userData.email_manual_disabled
        }"
        v-on:click="toggleSubscribe"
      >
        <span v-if="!userData.email_manual_disabled && !loading"
          >Unsubscribe</span
        >
        <span v-if="userData.email_manual_disabled && !loading">Subscribe</span>
        <span v-if="loading"
          ><i class="fas fa-spinner-third fa-fw fa-spin"></i
        ></span>
      </button>
    </div>
    <div
      class="flex flex-col text-center max-w-md bg-white p-4 rounded-lg"
      v-if="error"
    >
      <h1 class="font-medium text-xl">We've Encountered an Error</h1>
      <p class="mt-2">
        The unsubscribe link provided is not complete. Try clicking the link
        again at the bottom of the email or copy and paste the complete link.
      </p>
    </div>
  </div>
</template>

<script>
import * as Config from "@/config";

export default {
  name: "GeneralEmailUnsubscribe",
  data() {
    return {
      userData: null,
      error: false,
      loading: false
    };
  },
  async mounted() {
    await this.getMrId(this.$route.params.mrId);
  },
  methods: {
    async getMrId(mrId) {
      try {
        const res = await this.$http.get(
          Config.apiPath + "/api/v2/email/unsubscribe/" + mrId
        );
        this.userData = res.data;
      } catch (e) {
        this.error = true;
      }
    },
    async toggleSubscribe() {
      this.loading = true;
      try {
        const res = await this.$http.post(
          Config.apiPath +
            "/api/v2/email/subscribe/toggle/" +
            this.$route.params.mrId
        );
        this.userData = res.data;
        this.loading = false;
      } catch (e) {
        this.error = true;
      }
    }
  }
};
</script>
